import BaseModel from "./base/baseModel";

export default class ProdutoPerecivelFormaFarmaceuticaModel extends BaseModel {
    id?: number;
    produtoId: number;
    formaFarmaceuticaId: number;
    formaFarmaceuticaDescricao: string;
}
